export enum DocumentStatus {
  Signed = 'signed',
  PartlySigned = 'partly-signed',
  Approved = 'approved',
  Draft = 'draft',
  Rejected = 'rejected',
  Lost = 'lost',
  Recalled = 'recalled',
  Viewed = 'viewed',
  Sealed = 'sealed',
  Sent = 'sent',
  Reviewed = 'reviewed',
  SignedWithoutVerification = 'signedwithoutverification',
  Scheduled = 'scheduled',
  HardBounced = 'hardbounced',
  Importing = 'importing',
  Processing = 'processing',
}
